import { Instance } from 'mobx-state-tree'
import { createContext } from 'react'
import { Store } from '~models'

export const StoreContext = createContext<Instance<typeof Store> | undefined>(
  undefined,
)
